/* eslint-disable arrow-body-style */
import actionTypes from '../constants/action-types';
import serviceClient from '../../service-client/service-client';
import site from '../../site';
import fetchPageHTML from '../../site/helpers/fetch-page-html';
import injectActivePageHTML from '../helpers/inject-active-page-html';
import selectors from '../selectors';
import common from '../constants/common';

const siteLocales = (store) => (next) => async (action) => {
  switch (action.type) {
    case actionTypes.REMOVE_LOCALE: {
      const state = store.getState();
      const client = serviceClient.get();
      const siteId = site.selectors.getSiteId(state);
      const activePageId = site.selectors.getActivePageId(state);
      let activePage = site.selectors.getPage(state, activePageId);
      const locales = selectors.getSiteLocales(state);
      const isMultilingual = site.verifiers.isMultilingualSite();

      if (action.payload.locale === activePage.locale) {
        const mainLocale = selectors.getMainLocale(state);
        const pages = site.selectors.getPages(state);
        activePage =
          pages.find((page) => page.path === `/${mainLocale}/`) ||
          site.selectors.getHomePage(state, mainLocale);

        await site.operations.setActivePage(activePage.id);
      }

      try {
        const result = await client.removeSiteLocale(siteId, { locale: action.payload.locale });
        const { pages, deletionInfo } = result.data;
        const html = await fetchPageHTML(activePage.source);
        const newPages = injectActivePageHTML(pages, activePage.id, html);

        store.dispatch(site.actions.setPages(newPages));

        if (
          locales.length === common.MIN_LOCALES_BEFORE_REMOVAL_FOR_MONOLINGUAL_SITE &&
          isMultilingual
        ) {
          site.operations.setMultilingual(false);
        }

        action.payload.resolve({ newPages, deletionInfo });
        next(action);
      } catch (error) {
        console.error(error);
        action.payload.reject(error);
      }

      break;
    }

    default:
      next(action);
  }
};

export default siteLocales;
